import authFetch from "../utils/authFetch";

const API_BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;

export const createCheckoutSession = async (assetId) => {
  try {
    const response = await authFetch(
      `${API_BASE_URL}/api/user/marketplace/buy-nft/${assetId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
      },
    );
    return response;
  } catch (error) {
    console.error("Error creating checkout session:", error);
    throw error;
  }
};

export const getPaymentStatus = async (sessionId) => {
  try {
    const response = await authFetch(
      `${API_BASE_URL}/api/payments/status/${sessionId}`,
      {
        method: "GET",
      },
    );
    return response;
  } catch (error) {
    console.error("Error getting payment status:", error);
    throw error;
  }
};

// Stripe Connect Dashboard Functions
export const getStripeDashboardLink = async () => {
  try {
    const response = await authFetch(
      `${API_BASE_URL}/api/stripe-connect/creator/dashboard-link`,
      {
        method: "GET",
      },
    );
    return response;
  } catch (error) {
    console.error("Error getting Stripe dashboard link:", error);
    throw error;
  }
};

export const recordBlockchainPurchase = async (data) => {
  try {
    const response = await authFetch(
      `${API_BASE_URL}/api/user/marketplace/record-blockchain-purchase`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      },
    );
    return response;
  } catch (error) {
    console.error("Error recording blockchain purchase:", error);
    throw error;
  }
};

export const getStripeAccountStatus = async () => {
  try {
    const response = await authFetch(
      `${API_BASE_URL}/api/stripe-connect/creator/status`,
      {
        method: "GET",
      },
    );
    return response;
  } catch (error) {
    console.error("Error getting Stripe account status:", error);
    throw error;
  }
};
